var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "visual-tooltip-parking" }, [
    _vm.tooltip.number
      ? _c("div", { staticClass: "visual-tooltip-parking__title" }, [
          _vm._v("Место №" + _vm._s(_vm.tooltip.number)),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.tooltip.area
      ? _c("div", { staticClass: "visual-tooltip-parking__area" }, [
          _vm._v(_vm._s(_vm.replaceDotComma(_vm.tooltip.area)) + " м2"),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.tooltip.area
      ? _c(
          "div",
          {
            class: [
              "visual-tooltip-parking__price",
              { "is-new": _vm.tooltip.priceOld },
            ],
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.formatPrice(_vm.tooltip.price)) +
                " руб\n    "
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.tooltip.priceOld
      ? _c("div", { staticClass: "visual-tooltip-parking__price-old" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.formatPrice(_vm.tooltip.priceOld)) +
              " руб\n    "
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }